<div class="container"
  [formGroup]='parentForm'>
  <fun-input placeholder=""
    [parentForm]="parentForm"
    [formControlKeys]="formControlKeys"
    [errorMessages]="errorMessages"
    [isSubmit]="isSubmit"
    controlName="code"
    type="text"
    [errorLogin]="errorAmount"
    labelName="Código"
    (click)="validate()"
    (valueChanged)="validate()"
    (paste)="validate()"
    (keyup)="validate()"></fun-input>
</div>